import { render, staticRenderFns } from "./PlanTag.vue?vue&type=template&id=ce23ff10&"
import script from "./PlanTag.vue?vue&type=script&lang=js&"
export * from "./PlanTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports